export default "__VITE_ASSET__Dy$hrnzR__"